<!--MAIN NAVIGATION-->
<!--===================================================-->
<nav id="mainnav-container">
  <div id="mainnav">
    <!--Menu-->
    <!--================================-->
    <div id="mainnav-menu-wrap">
      <div class="nano">
        <div class="nano-content">
          <!--Profile Widget-->
          <!--================================-->
          <div id="mainnav-profile" class="mainnav-profile">
            <div class="profile-wrap">
              <div class="pad-btm">
                <img *ngIf="profilePicture" class="img-square img-sm" [src]="profilePicture" [alt]="user.RazaoSocial">
              </div>
              <a href="#profile-nav" class="box-block collapsed" data-toggle="collapse" aria-expanded="false">
                <p class="mnp-name">
                  <span *ngIf="user && (user.RazaoSocial || user.Fantasia)">{{ user.RazaoSocial || user.Fantasia }}</span>
                </p>
                <span *ngIf="user && user.CpfCnpj" class="mnp-desc">{{user.CpfCnpj}}</span>
                <i class="pull-right ti-angle-down"></i>
              </a>
            </div>
            <div id="profile-nav" class="collapse list-group bg-trans">
              <a *ngIf="user && user.TipoCadastro && user.TipoCadastro === 'PagueLa'" [routerLink]="['/minha-conta/lancamentos-futuros']" [routerLinkActive]="['active-link']" class="list-group-item">
                <svg id="a38ddaa7-4d88-467e-85db-37eb41672c0f" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Lanç. Futuros</title>
                  <path d="M9.68,27H1V24H6.78A10.76,10.76,0,0,0,9.68,27ZM5.05,19H1v3H5.75A10.68,10.68,0,0,1,5.05,19Zm.7-5H1v3H5.05A10.68,10.68,0,0,1,5.75,14Zm18,11.78A10.61,10.61,0,0,1,22.32,27H31V24H25.22A11.22,11.22,0,0,1,23.78,25.78ZM26.25,22H31V19H27A10.68,10.68,0,0,1,26.25,22Zm.7-5H31V14H26.25A10.68,10.68,0,0,1,27,17Zm-3.17-6.78A11.22,11.22,0,0,1,25.22,12H31V9H22.32A10.61,10.61,0,0,1,23.78,10.22ZM17,4V7H31V4Zm7.5,14.5A8.5,8.5,0,1,1,16,10,8.51,8.51,0,0,1,24.5,18.5Zm-2,0A6.5,6.5,0,1,0,16,25,6.51,6.51,0,0,0,22.5,18.5Zm-5.44-.75H14.94c-.53,0-1-.34-1-.74s.46-.74,1-.74H18.8v-1.5H17V13.5H15v1.27h-.06A2.38,2.38,0,0,0,12.45,17a2.38,2.38,0,0,0,2.49,2.24h2.12c.53,0,1,.34,1,.74s-.46.74-1,.74H13.2v1.5H15V23.5h2V22.23h.06A2.38,2.38,0,0,0,19.55,20,2.38,2.38,0,0,0,17.06,17.75Z"
                  style="fill:#7f47d1" />
                </svg>
                <span class="menu-title">
                  <strong>Lanç. Futuros</strong>
                </span>
              </a>
              <!-- <a *ngIf="user && (!user.TipoCadastro || (user.TipoCadastro && user.TipoCadastro !== 'PagueLa'))" [routerLink]="['/minha-conta/faturamento']" [routerLinkActive]="['active-link']" class="list-group-item">
                <svg id="a38ddaa7-4d88-467e-85db-37eb41672c0f" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Faturamento</title>
                  <path d="M9.68,27H1V24H6.78A10.76,10.76,0,0,0,9.68,27ZM5.05,19H1v3H5.75A10.68,10.68,0,0,1,5.05,19Zm.7-5H1v3H5.05A10.68,10.68,0,0,1,5.75,14Zm18,11.78A10.61,10.61,0,0,1,22.32,27H31V24H25.22A11.22,11.22,0,0,1,23.78,25.78ZM26.25,22H31V19H27A10.68,10.68,0,0,1,26.25,22Zm.7-5H31V14H26.25A10.68,10.68,0,0,1,27,17Zm-3.17-6.78A11.22,11.22,0,0,1,25.22,12H31V9H22.32A10.61,10.61,0,0,1,23.78,10.22ZM17,4V7H31V4Zm7.5,14.5A8.5,8.5,0,1,1,16,10,8.51,8.51,0,0,1,24.5,18.5Zm-2,0A6.5,6.5,0,1,0,16,25,6.51,6.51,0,0,0,22.5,18.5Zm-5.44-.75H14.94c-.53,0-1-.34-1-.74s.46-.74,1-.74H18.8v-1.5H17V13.5H15v1.27h-.06A2.38,2.38,0,0,0,12.45,17a2.38,2.38,0,0,0,2.49,2.24h2.12c.53,0,1,.34,1,.74s-.46.74-1,.74H13.2v1.5H15V23.5h2V22.23h.06A2.38,2.38,0,0,0,19.55,20,2.38,2.38,0,0,0,17.06,17.75Z"
                  style="fill:#7f47d1" />
                </svg>
                <span class="menu-title">
                  <strong>Faturamento</strong>
                </span>
              </a> -->
              <a [routerLink]="['/minha-conta/configuracoes']" [routerLinkActive]="['active-link']" class="list-group-item">
                <svg id="7ddbdef8-a9c2-4822-b99b-377789c13510" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Configurações</title>
                  <path d="M19.55,19.66l2.28-1.06L20.15,15l-2.27,1.06a8.27,8.27,0,0,0-1.48-1.36l.85-2.36L13.53,11l-.86,2.36a7.56,7.56,0,0,0-2,.09L9.6,11.17,6,12.85l1.06,2.27A8.27,8.27,0,0,0,5.71,16.6l-2.36-.85L2,19.47l2.36.86a7.57,7.57,0,0,0,.09,2L2.17,23.4,3.85,27l2.27-1.06A8.27,8.27,0,0,0,7.6,27.29l-.85,2.36L10.47,31l.86-2.36a7.57,7.57,0,0,0,2-.09l1.06,2.28L18,29.15l-1.06-2.27a8.27,8.27,0,0,0,1.36-1.48l2.36.85L22,22.53l-2.36-.86A7.56,7.56,0,0,0,19.55,19.66ZM7.47,23.11a5,5,0,1,1,6.64,2.42A5,5,0,0,1,7.47,23.11ZM30,8.2V5.8H28.46A4.28,4.28,0,0,0,28,4.69L29.09,3.6,27.4,1.91,26.31,3a4.28,4.28,0,0,0-1.11-.46V1H22.8V2.53A5.1,5.1,0,0,0,21.69,3L20.6,1.91,18.91,3.6,20,4.69a4.28,4.28,0,0,0-.46,1.11H18V8.2h1.54A4.28,4.28,0,0,0,20,9.31L18.91,10.4l1.69,1.69L21.69,11a5.1,5.1,0,0,0,1.11.46V13h2.4V11.46A4.28,4.28,0,0,0,26.31,11l1.09,1.09,1.69-1.69L28,9.31a4.28,4.28,0,0,0,.46-1.11ZM26,9H22V5h4Z"
                  style="fill:#7f47d1" />
              </svg>
                <span class="menu-title">
                  <strong>Configurações</strong>
                </span>
              </a>
            </div>
          </div>
          <ul *ngIf="user" id="mainnav-menu" class="list-group">
            <li [routerLinkActive]="['active-link']">
              <a class="nav-item" [routerLink]="['/visao-geral']">
                <svg id="119832c4-f061-40c4-b971-caee2454a0a5" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Visão Geral</title>
                  <path d="M12,23H8V18h4Zm8,0V15H16v8Zm4,0h4V12H24ZM5,26V5H2.07V29H30V26ZM15.41,10h6l5.3-5.29L25.29,3.29,20.59,8h-6l-5.3,5.29,1.42,1.42Z"
                      style="fill: #4379ff;" />
              </svg>
                <span class="menu-title">
                  <strong>Visão Geral</strong>
                </span>
              </a>
            </li>
            <li [routerLinkActive]="['active-link']">
              <a class="nav-item" [routerLink]="['/transacoes']">
                <svg id="85a248d8-8312-45f8-9c34-db2672ee7252" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Transações</title>
                  <path d="M1,16V26a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3V16Zm3,3h6v2H4Zm12,7H4V24H16Zm9-13H1v0a3,3,0,0,1,3-3H22a3,3,0,0,1,3,3Zm3-9a3,3,0,0,1,3,3h0V21a3,3,0,0,1-3,3h0V10a3,3,0,0,0-3-3H6A3,3,0,0,1,9,4Z"
                  style="fill: #4379ff;" />
              </svg>
                <span class="menu-title">
                  <strong>Transações</strong>
                </span>
              </a>
            </li>
            <li [routerLinkActive]="['active-link']">
              <a class="nav-item" [routerLink]="['/cobrancas-pix']">
                <svg id="pix-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>PIX</title>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M242.4 292.5c5.4-5.4 14.7-5.4 20.1 0l77 77c14.2 14.2 33.1 22 53.1 22l15.1 0-97.1 97.1c-30.3 29.5-79.5 29.5-109.8 0l-97.5-97.4 9.3 0c20 0 38.9-7.8 53.1-22l76.7-76.7zm20.1-73.6c-6.4 5.5-14.6 5.6-20.1 0l-76.7-76.7c-14.2-15.1-33.1-22-53.1-22l-9.3 0 97.4-97.4c30.4-30.3 79.6-30.3 109.9 0l97.2 97.1-15.2 0c-20 0-38.9 7.8-53.1 22l-77 77zM112.6 142.7c13.8 0 26.5 5.6 37.1 15.4l76.7 76.7c7.2 6.3 16.6 10.8 26.1 10.8 9.4 0 18.8-4.5 26-10.8l77-77c9.8-9.7 23.3-15.3 37.1-15.3l37.7 0 58.3 58.3c30.3 30.3 30.3 79.5 0 109.8l-58.3 58.3-37.7 0c-13.8 0-27.3-5.6-37.1-15.4l-77-77c-13.9-13.9-38.2-13.9-52.1 .1l-76.7 76.6c-10.6 9.8-23.3 15.4-37.1 15.4l-31.8 0-58-58c-30.3-30.3-30.3-79.5 0-109.8l58-58.1 31.8 0z"/></svg>
              </svg>
                <span class="menu-title">
                  <strong>PIX</strong>
                </span>
              </a>
            </li>
            <li [routerLinkActive]="['active-link']">
              <a class="nav-item" [routerLink]="['/vendas']">
                <svg id="85a248d8-8312-45f8-9c34-db2672ee7252" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Vendas</title>
                  <path d="M1,16V26a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3V16Zm3,3h6v2H4Zm12,7H4V24H16Zm9-13H1v0a3,3,0,0,1,3-3H22a3,3,0,0,1,3,3Zm3-9a3,3,0,0,1,3,3h0V21a3,3,0,0,1-3,3h0V10a3,3,0,0,0-3-3H6A3,3,0,0,1,9,4Z"
                  style="fill: #4379ff;" />
              </svg>
                <span class="menu-title">
                  <strong>Vendas</strong>
                </span>
              </a>
            </li>
            <li [routerLinkActive]="['active-link']" *ngIf="isTipoPagueLa()">
              <a class="nav-item" [routerLink]="['/agenda-financeira']">
                <svg id="7482665e-b4c9-49bc-b9dc-002497f9e522" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Agendas Financeiras</title>
                  <path d="M22,22.5A11,11,0,0,1,12.47,17H2V27a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V21.75A11.07,11.07,0,0,1,22,22.5ZM5,20h6v2H5Zm12,7H5V25H17ZM11.29,14H2v0a3,3,0,0,1,3-3h6c0,.17,0,.33,0,.5A10.83,10.83,0,0,0,11.29,14ZM22,20a8.5,8.5,0,1,1,8.5-8.5A8.51,8.51,0,0,1,22,20ZM22,5a6.5,6.5,0,1,0,6.5,6.5A6.51,6.51,0,0,0,22,5Zm1,7.5H19v-2h2V7h2Z"
                  style="fill: #4379ff;" />
              </svg>
                <span class="menu-title">
                  <strong>Agenda Financeira</strong>
                </span>
              </a>
            </li>
            <li [routerLinkActive]="['active-link']" *ngIf="isAdmin">
              <a href="#boletos-nav" class="box-block boletos-nav collapsed nav-item" data-toggle="collapse" aria-expanded="false">
                <svg id="f6692267-c5c4-49dd-855b-e5ab2e92a894" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>Boletos</title>
                  <path d="M23,31H3V7H18.41L23,11.59ZM5,29H21V12.41L17.59,9H5Zm13-6H8v2H18ZM20,5l5,5V25h3V6L24,2H9V5Z" style="fill: #4379ff;"
                  />
              </svg>
                <span class="menu-title">
                  <strong>Boletos</strong>
                </span>
              </a>
              <div id="boletos-nav" class="collapse list-group bg-trans">
                <a class="nav-item list-group-item" [routerLinkActive]="['active-link']" [routerLink]="['/boletos/todos-boletos']">
                  <span class="menu-title">
                    <strong>Boletos</strong>
                  </span>
                </a>
                <a class="nav-item list-group-item" [routerLinkActive]="['active-link']" [routerLink]="['/boletos/retorno']">
                  <span class="menu-title">
                    <strong>Retornos</strong>
                  </span>
                </a>
              </div>
            </li>
            <li [routerLinkActive]="['active-link']" *ngIf="isAdmin">
              <a class="nav-item" [routerLink]="['/nfse']">
                <svg id="2b8b1aa8-2392-4597-b54e-a27a48e31c6e" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                  <title>nfs-e</title>
                  <path d="M27,29H6V3H22.41L27,7.59ZM8,27H25V8.41L21.59,5H8ZM21.71,13.71l-1.42-1.42L15,17.59l-2.29-2.3-1.42,1.42L15,20.41Z"
                  style="fill: #4379ff;" />
              </svg>
                <span class="menu-title">
                  <strong>NFS-e</strong>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
